// extracted by mini-css-extract-plugin
export default {"p_content":"fef9078e4e"};